import React, { useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AxiosUrl from "../AxiosUrl";
import { toast } from "react-toastify";

export const DeletePaymentModal = ({ payment, onSuccess }) => {
  const handleDelete = () => {
    confirmAlert({
      title: "Confirm Delete",
      message: `Are you sure you want to delete this ${payment.paymentType} payment of ৳${payment.Amount}?`,
      buttons: [
        {
          label: "Yes, Delete",
          onClick: async () => {
            const uid = localStorage.getItem("id");
            try {
              const response = await AxiosUrl.post(`/delete-bkash-payment/${uid}`, {
                paymentId: payment._id,
                paymentType: payment.paymentType,
              });

              if (response.data.success) {
                toast.success("Payment deleted successfully");
                if (onSuccess) onSuccess();
              } else {
                toast.error(response.data.error || "Failed to delete payment");
              }
            } catch (error) {
              console.error("Delete error:", error);
              toast.error("Failed to delete payment");
            }
          },
        },
        {
          label: "Cancel",
          onClick: () => {},
        },
      ],
    });
  };

  return handleDelete;
};

export default DeletePaymentModal;
